// ============================================================================
// MetaForm (L16, F-837/F-838 + M-806) — auto-edition titre + description
// ============================================================================
// Portage de (dashboard)/profile/meta-form.tsx. M-807 : AUCUN champ de ciblage —
// le hook tape /api/profile/me/meta et le serveur prend l'email du TOKEN. Il est
// structurellement impossible d'editer un tiers depuis ce formulaire.
// M-806 : titre <= 100 car., description <= 500 car. — maxLength ici est une
// affordance ; le serveur revalide (Zod) et reste l'autorite.

import { useState } from 'react';
import { GS_COMPONENTS } from '@gs/ui';
import { useTranslation } from '../../i18n';
import { useUpdateMyMeta, profileErrorCode } from '../../hooks/useProfile';

export interface MetaFormProps {
  initialJobTitle: string | null;
  initialTasksDescription: string | null;
}

export function MetaForm({ initialJobTitle, initialTasksDescription }: MetaFormProps) {
  const { t } = useTranslation();
  const update = useUpdateMyMeta();
  const [jobTitle, setJobTitle] = useState(initialJobTitle ?? '');
  const [tasks, setTasks] = useState(initialTasksDescription ?? '');

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    // M-806 : '' -> null (convention « absence = null »), trim cote serveur aussi.
    update.mutate({
      jobTitle: jobTitle.trim() === '' ? null : jobTitle.trim(),
      tasksDescription: tasks.trim() === '' ? null : tasks.trim(),
    });
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <label htmlFor="profile-job-title" className="text-meta font-medium text-slate-600 dark:text-slate-300">
          {t('gest:profile.meta.jobTitle')}
        </label>
        <input
          id="profile-job-title"
          type="text"
          maxLength={100}
          value={jobTitle}
          onChange={(e) => setJobTitle(e.target.value)}
          className={GS_COMPONENTS.input}
        />
      </div>
      <div className="flex flex-col gap-1">
        <label htmlFor="profile-tasks" className="text-meta font-medium text-slate-600 dark:text-slate-300">
          {t('gest:profile.meta.tasksDescription')}
        </label>
        <textarea
          id="profile-tasks"
          rows={4}
          maxLength={500}
          value={tasks}
          onChange={(e) => setTasks(e.target.value)}
          className={GS_COMPONENTS.input}
        />
      </div>

      <div className="flex items-center gap-3">
        <button
          type="submit"
          disabled={update.isPending}
          className={`${GS_COMPONENTS.btnAction} touch-manipulation disabled:opacity-50`}
        >
          {t('gest:profile.meta.save')}
        </button>
        {/* F-838 : message de resultat (jamais un code brut a l'ecran — GA-21). */}
        {update.isSuccess ? (
          <p role="status" className="text-meta text-emerald-700 dark:text-emerald-400">
            {t('gest:profile.meta.saved')}
          </p>
        ) : null}
        {update.isError ? (
          <p role="alert" className="text-meta text-red-700 dark:text-red-400">
            {t(`gest:profile.errors.${profileErrorCode(update.error)}`)}
          </p>
        ) : null}
      </div>
    </form>
  );
}
